{
  "01a48705b40e69f7": "Filter by name or document ID",
  "03867aea70acaf4c": "Evidence",
  "069d7e9d898e4d81": "Worker ID",
  "0b1548eb25a9799d": "Failed to load document preview.",
  "0cd55c8e8865f98b": "Unknown definition",
  "19fbc2613e4a1d81": "Loading document preview...",
  "1a83135d903dcd9e": "Evidence Definition",
  "1ea442a134b2a184": "No",
  "2677214a9268a547": "In Review",
  "271d48fc7d5d9dd4": "Evidence updated successfully",
  "29c37ce298a5399a": "Failed to load evidence definitions. Evidence properties cannot be edited.",
  "2aa9e2ac7a12cb55": "Select a definition",
  "2cd3f75e8d4737b4": "Evidence definition not found. Evidence properties cannot be edited.",
  "2ed9337dcc8cf799": "View evidence",
  "2f2a95ec93b25e34": "Document ID",
  "2f491f07735e7056": "Definition Name",
  "331551b0de4157c9": "Pending",
  "356358348d9a0262": "Start typing to search evidence definitions",
  "3d03011c07c575f8": "Worker evidence sections",
  "3d44337010bfbdf7": "Created At",
  "4976197fe3f2bdd4": "Please enter a valid Worker ID to view documents and evidences.",
  "5265434bb9e0e789": "Failed to load documents. Please try again.",
  "6cbf9de5aca6b84c": "No documents match the filter.",
  "6e9a4c33b916d1a4": "No evidence definitions found",
  "6ee7448a9c057091": "Evidences",
  "6f5708dda91a3dd7": "Select {{fieldKey}}",
  "6fed375409557a57": "Failed to load evidences. Please try again.",
  "76f14c379dff48a2": "No documents found for this worker.",
  "799ccd9dee898c80": "Existing Documents",
  "85a39ab345d672ff": "Yes",
  "87b42e40c2a290e0": "Approved",
  "8c13bf02a1a2b30e": "Worker Evidences",
  "920e413c7d411b61": "Status",
  "94d5a7703a8250de": "Filter by status",
  "9569cdd073575b1d": "No evidences match the filter.",
  "a5cc6e9c339ea39b": "Filter by definition name or evidence ID",
  "aea4a04a80426ed8": "Rejected",
  "b4aaa11cf013f6d7": "Failed to load evidences. Evidence linking may be incomplete.",
  "b5b8cb11a02602cf": "View document",
  "b89ab3b119b92f94": "Edit Evidence",
  "bc601ec106f42318": "Evidence created successfully",
  "d1957085c29dbd37": "Evidence ID",
  "d600e62a6861fced": "Expiry Date",
  "d8500d3836a2086e": "Select an evidence definition to continue.",
  "dcd1d5223f73b3a9": "Name",
  "e198269c2a19003d": "An unexpected error occurred. Please try again.",
  "e35c8e4f5cb5c554": "Updated At",
  "e6db68ccd8cfaca3": "No evidences found for this worker.",
  "e87247d44d94398d": "This definition has no properties to fill in.",
  "ed71fe3a468e163d": "Searching evidence definitions...",
  "ed82cf60e617eb63": "Search by name...",
  "fea31386a31f34c6": "Failed to load evidence definitions. Please try again.",
  "ff8059dc6752afdd": "Actions"
}
